import {useEffect, useState} from 'react';
import {isTreez} from '../../../lib/auth/ping/types/PingUser';
import {DEFAULT_ROUTABLE_ORG_ID} from '../UIWrapper';

export const useUIWrapperAccess = ({organizationId, userOrgIds, user}) => {
    const [hasAccess, setHasAccess] = useState<boolean>(false);

    useEffect(() => {
        if (Number(organizationId) === DEFAULT_ROUTABLE_ORG_ID) {
            setHasAccess(false);
        } else {
            setHasAccess((userOrgIds || []).includes(Number(organizationId)) || isTreez(user));
        }
    }, [organizationId, userOrgIds, user]);

    return {hasAccess};
};
